import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { OrderService } from "../../../services/order-service";
import { Formik } from "formik";
import * as Yup from "yup";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import Select from "react-select";
import { AdminService } from "../../../services/admin-service";
import moment from "moment";
import { INVOICE_URL } from "../../../config/constants";

export const Orderdetails = (props) => {

  const authPermission = localStorage.getItem("PermissionDetails");
    const [statusHide, setHideStatus] = useState(false);

  useEffect(() => {
      JSON.parse(authPermission).forEach(function (loca) {  
        if (
          loca.access_level.access_level == "STORE_USER"
        ) {
          setHideStatus(true);
        }
      });
    }, [authPermission]);

  const format2 = "YYYY-MM-DD";
  const { orderID } = useParams();

  const [submitloading, setSubmitLoading] = useState(true);

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    try {
      // Define the initial values (taken from props)
        const initialValues = {
          special_note: props.special_note,
          status: props.status,
          payment_status: props.payment_status,
        };

        // Get only changed fields
        const changedValues = {};
        Object.keys(values).forEach((key) => {
          if (values[key] !== initialValues[key]) {
            changedValues[key] = values[key];
          }
        });

        if (Object.keys(changedValues).length === 0) {
          notifyWarning("No changes detected");
          setSubmitLoading(true);
          return;
        }

      await OrderService.orderUpdate(props.id, changedValues);
      setSubmitLoading(true);
      props.OrderSearchID();
      notify("Order status successfully updated");
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  useEffect(() => {
    adminSearch();
  }, []);

  const [admin, setAdmin] = useState([]);

  const adminSearch = async () => {
    try {
      const result = await AdminService.adminDetails();

      setAdmin(result);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const AdminDetails = admin.map((admin) => {
    const container = {};

    container["value"] = admin.id;
    container["label"] = admin.name;

    return container;
  });

  return (
    <div className="col-xl-12 col-md-12">
      <div className="ms-panel ms-panel-fh">
        <div className="ms-panel-body">
          <h2 className="section-title">Basic Information</h2>
          <table className="table ms-profile-information">
            <tbody>
              <tr>
                <th scope="row">Order No</th>
                <td><a href={INVOICE_URL+props.order_id} target="_blank" >{props.order_id}</a></td>
              </tr>
              {/* {props.payment_status == "APPROVED" && 
              <tr>
                <th scope="row">Invoice</th>
                <td><a href={`https://l-kuppiya-store-invoice.web.app/?${props.order_id}`} target="_blank" >View Invoice</a></td>
              </tr>} */}
              <tr>
                <th scope="row">Total Weight</th>
                <td>{props.total_weight}kg</td>
              </tr>
              <tr>
                <th scope="row">Sub Total</th>
                <td>Rs.{props.sub_total}.00</td>
              </tr>
              <tr>
                <th scope="row">Discount</th>
                <td>Rs.{props.discount}.00</td>
              </tr>
              <tr>
                <th scope="row">Delivery Fee</th>
                <td>Rs.{props.delivery_fee}.00</td>
              </tr>
              <tr>
                <th scope="row">Total Amount</th>
                <td>Rs.{props.total}.00</td>
              </tr>
              <tr>
                <th scope="row">Payment Status</th>
                {props.payment_status == "PENDING" ? (
                  <td><span className="badge badge-warning">PENDING</span></td>
                  ) : props.payment_status == "APPROVED" ? (
                    <td><span className="badge badge-success">APPROVED</span></td>
                  ) : props.payment_status == "CANCELED" ? (
                    <td><span className="badge badge-danger">CANCELED</span></td>
                  ) : props.payment_status == "FAILED" ? (
                    <td><span className="badge badge-primary">FAILED</span></td>
                  ) : (
                    <td><span className="badge badge-dark">CHANGEBACK</span></td>
                  )
                }
              </tr>
              <tr>
                <th scope="row">Payment Type</th>
                {props.payment_method == "CASH_ON_DELIVERY" ? (
                  <td>CASH ON DELIVERY</td>
                ) : props.payment_method == "PAYHERE" ? (
                  <td>{props.payment_method}</td>
                ) : (
                <td>BANK DEPOSIT</td>
              )}
             </tr>
             {props.bdApproved_time ? (
                <>
                <tr>
                  <th scope="row">BD Approved By</th>
                  <td>{props.bdApproved_by}</td>

                </tr>
                <tr>
                  <th scope="row">BD Approved Time</th>
                  <td> {moment(props.bdApproved_time).format('YYYY-MM-DD HH:mm:ss')} </td>
                </tr> 
                </> 
              ) : ''}
              {/* <tr>
                <th scope="row">Note</th>
                <td>{props.note}</td>
              </tr> */}
              <tr>
                <th scope="row">Order Date </th>
                <td> {moment(props.order_date).format(format2)}</td>
              </tr>
              {/* <tr>
                <th scope="row">Received Time</th>
                <td>{props.received_time}</td>
              </tr> */}
              {props.preparing_started_time ? (
                <>
                <tr>
                  <th scope="row">Ready To Ship By</th>
                  <td>{props.prepared_by}</td>
                </tr>
                <tr>
                  <th scope="row">Ready To Ship Time</th>
                  <td>{ moment(props.preparing_started_time).format('YYYY-MM-DD HH:mm:ss')}</td>
                </tr>
                </>
              ) : ''}
              {/* <tr>
                <th scope="row">Driver Requested Time</th>
                <td>{props.driver_requested_time}</td>
              </tr> */}
              {props.dispatched_time ? (
                <>
                <tr>
                  <th scope="row">Shipped By</th>
                  <td>{props.dispatched_by}</td>

                </tr>
                <tr>
                  <th scope="row">Shipped Time</th>
                  <td> {moment(props.dispatched_time).format('YYYY-MM-DD HH:mm:ss')} </td>
                </tr> 
                </> 
              ) : ''}
              {props.completed_time != null ? (
                <>
                  <tr>
                    <th scope="row">Completed By</th>
                    <td>{props.completed_by}</td>
                  </tr>
                  <tr> 
                    <th scope="row">Completed Time</th>
                    <td>
                      {props.completed_time ? moment(props.completed_time).format('YYYY-MM-DD HH:mm:ss') : ''}
                    </td>
                  </tr>
                </>
              ) : ''}
              {props.cancelled_time != null ? (
                <>
                <tr>
                  <th scope="row">Cancelled By</th>
                  <td>{props.cancelled_by}</td>

                </tr>
                <tr>
                  <th scope="row">Cancelled Time</th>
                  <td>
                  {moment(props.cancelled_time).format('YYYY-MM-DD HH:mm:ss')}
                  </td>
                </tr>
                </>
              ) : props.cancelled_reason !== "" ? (
                <tr>
                  <th scope="row">Cancelled Reason</th>
                  <td>{props.cancelled_reason}</td>
                </tr>
              ) : (
                <tr></tr>
              )}

              {/* <tr>
                <th scope="row">Created At</th>
                <td> {moment(props.created_at).format(format2)} </td>
              </tr>
              <tr>
                <th scope="row">Updated At</th>
                <td> {moment(props.updated_at).format(format2)} </td>
              </tr> */}
            </tbody>
          </table>

          {/* <h2 className="section-title mt-5">Delivery Information</h2>
          <table className="table ms-profile-information">
            <tbody>
              <tr>
                <th scope="row">City</th>
                <td>{props.delivery_city}</td>
              </tr>
              <tr>
                <th scope="row">Address</th>
                <td>{props.delivery_address}</td>
              </tr>
            </tbody>
          </table> */}
        </div>

        <div className="ms-panel-body">
          <Formik
            enableReinitialize={true}
            initialValues={{
              special_note: props.special_note,
              status: props.status,
              payment_status: props.payment_status,
            }}
            validationSchema={Yup.object().shape({
              status: Yup.string().required("Required"),
            })}
            onSubmit={onSubmitForm}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              touched,
              values,
              submitForm,
              isValid,
              setFieldValue,
            }) => (
              <>
              <div className="form-row">
                <label htmlFor="validationCustom08">Special Note</label>
                  <div className="input-group">
                    <textarea
                      name="special_note"
                      className="form-control"
                      id="spNoteId"
                      rows="4" 
                      cols="50"
                      required
                      onChange={(e) => {
                        setFieldValue("special_note", e.target.value);
                      }}
                      onBlur={handleBlur}
                      value={values.special_note}
                    >
                    </textarea>
                  </div>
                  <div style={{ color: "red", fontSize: "12px" }}>
                      {touched.note && errors.note}
                  </div>
              </div>
              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="validationCustom15">Status</label>
                  <div className="input-group">
                    <select
                      name="status"
                      className="form-control"
                      id="selectstatus"
                      required
                      value={values.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={props.status == 'CANCELED' || props.status == 'COMPLETED'}
                    >
                      <option value="PENDING" disabled={statusHide}>PENDING</option>
                      <option value="PREPARING">READY TO SHIP</option>
                      <option value="DELIVERING">SHIPPED</option>
                      <option value="COMPLETED" disabled={statusHide}>COMPLETED</option>
                      <option value="CANCELED" disabled={statusHide}>CANCELED</option>
                    </select>
                  </div>
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {touched.status && errors.status}
                  </div>
                </div>

                {(props.payment_method == "BANK_DEPOSIT" || props.payment_method == "CASH_ON_DELIVERY") ? (
                  <div className="col-md-6 mb-3">
                    <label htmlFor="validationCustom08">Payment Status</label>
                    <select
                      name="payment_status"
                      className="form-control"
                      id="selectpaymentstatus"
                      required
                      value={values.payment_status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="PENDING">PENDING</option>
                      <option value="APPROVED">APPROVED</option>
                      <option value="FAILED">FAILED</option>
                      <option value="CANCELED">CANCELED</option>
                      <option value="CHANGEBACK">CHANGEBACK</option>
                    </select>
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {touched.payment_status && errors.payment_status}
                    </div>
                  </div>
                ) : (
                  <div className="col-md-6 mb-3">
                    <label htmlFor="validationCustom08">Payment Status</label>
                    <select
                      name="paymentstatus"
                      className="form-control"
                      id="selectpaymentstatus"
                      required
                      value={values.payment_status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled
                    >
                      <option value="PENDING">PENDING</option>
                      <option value="APPROVED">APPROVED</option>
                      <option value="FAILED">FAILED</option>
                      <option value="CANCELED">CANCELED</option>
                      <option value="CHANGEBACK">CHANGEBACK</option>
                    </select>
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {touched.payment_status && errors.payment_status}
                    </div>
                  </div>
                )}
                <div className="form-row">
                  <div className="col-md-6 mb-3"></div>
                </div>
                <div className="form-row">
                  <div className="col-md-2" hidden={submitloading}>
                    <div className="spinner spinner-7">
                      <div className="bounce1" />
                      <div className="bounce2" />
                      <div className="bounce3" />
                    </div>
                  </div>
                </div>
                <div
                  className="form-row"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                <button
                    type="button"
                    className="btn btn-primary shadow-none"
                    disabled={props.status == 'CANCELED'}
                    onClick={submitForm}
                  >
                    Update
                  </button>
                </div>
              </div>
              </>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Orderdetails;
